export default function(doc) {
  if (doc.isBroken) {
    return '/not-found'
  }

  if (doc.type === 'post') {
    let lang = doc.lang.substr(0, 2)
    lang === 'en' ? (lang = `/`) : (lang = `/${lang}/`)
    return `${lang}blog/${doc.data.category.uid}/${doc.uid}`
  }

  if (doc.type === 'blog_category') {
    let lang = doc.lang.substr(0, 2)
    lang === 'en' ? (lang = `/`) : (lang = `/${lang}/`)
    return `${lang}blog/${doc.uid}`
  }

  if (doc.type === 'page') {
    let lang = doc.lang.substr(0, 2)
    lang === 'en' ? (lang = `/`) : (lang = `/${lang}/`)
    return `${lang}${doc.uid}`
  }

  return '/not-found'
}
